import { DASHBOARD_DOWNLOAD_RECORDS_API } from "../apiEndPoint/apiEndPoint";

export const downloadRecordsFetchCall = async (data:any,csrfVal:any)=>{
    const response = await fetch(`${DASHBOARD_DOWNLOAD_RECORDS_API}`, {
        method: "POST",
        headers: {
          Range: `bytes=${data.startRange}-`,
          siteId: data.siteId,
          Authorization: `Bearer ${data.authorization}`,
          Accept: "*/*",
          "Content-Type": "application/json",
          "Accept-Encoding": "gzip, deflate, br",
          Connection: "keep-alive",
          "X-XSRF-TOKEN": csrfVal,
        },
        body: JSON.stringify(data.param),
      });
    return response;
}

